import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { Checkbox, FormControlLabel } from '@mui/material';
import withTypeAdd from '../../HOCs/withTypeAdd';
import changeConditionForm from '../../HOCs/changeConditionForm';

const DeviceAssignmentReasonsAdd = props => {
    const {
        data: { name, commentIsRequired = false, description },
        errors,
        t
    } = props;

    return (
        <React.Fragment>
            <FormControl
                fullWidth
                required
                error={!!errors.name}
                margin="normal"
                variant="standard"
            >
                <InputLabel
                    htmlFor="deviceAssignmentReason"
                    variant="standard"
                >
                    {t('deviceAssignmentReason')}
                </InputLabel>
                <Input
                    id="deviceAssignmentReason"
                    autoFocus
                    name="name"
                    value={name || ''}
                    onChange={props.handleChange}
                />
                {errors.name && (
                    <FormHelperText>
                        {t(errors.name)}
                    </FormHelperText>
                )}
            </FormControl>
            <FormControl
                fullWidth
                margin="dense"
            >
                <FormControlLabel
                    control={(
                        <Checkbox
                            checked={commentIsRequired}
                            name="commentsAreRequired"
                            onChange={() =>
                                props.handleChange({
                                    target: { name: 'commentIsRequired', value: !commentIsRequired }
                                })}
                        />
                    )}
                    label={t('commentsAreRequired')}
                />
            </FormControl>
            <FormControl
                fullWidth
                error={!!errors.description}
                variant="standard"
            >
                <InputLabel
                    htmlFor="description"
                    variant="standard"
                >
                    {t('description')}
                </InputLabel>
                <Input
                    multiline
                    rows="4"
                    id="description"
                    name="description"
                    value={description || ''}
                    onChange={props.handleChange}
                />
                {errors.description && (
                    <FormHelperText>
                        {t(errors.description)}
                    </FormHelperText>
                )}
            </FormControl>
        </React.Fragment>
    );
};

const validate = data => {
    const errors = {};

    if (!data.name) errors.name = 'nameIsRequired';
    else if (data.name.length > 100) errors.name = 'deviceAssignmentReasonCannotBeLonger100';
    else if (data.name.length < 2) errors.name = 'deviceAssignmentReasonCannotBeAtLeast2';

    if (data.description?.length > 255) errors.description = 'descriptionCannotBeLonger255';
    return errors;
};

DeviceAssignmentReasonsAdd.propTypes = {
    handleChange: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

export default compose(withTypeAdd(validate), changeConditionForm)(DeviceAssignmentReasonsAdd);
